export const environment = {
    production: true,
    api_url_base_assignation_business: '###{secure_comm_api_base_url}###/api/maintenance-assignation',
    api_url_base_validate_access: '###{secure_comm_api_base_url}###/api',
    // Secure-Comm Gateway Configuration
    secureComm: {
        apiBaseUrl: '###{secure_comm_api_base_url}###'
    }
};
